import { LOCATION_CHANGE } from 'connected-react-router';

import { RECEIVE_CTO_COLOR } from './cto-actions';

const NULL_STATE = {};

const AddOnReducer = (state = NULL_STATE, action) => {
	Object.freeze(state);
	switch(action.type) {
		case LOCATION_CHANGE:
			return NULL_STATE;
		case RECEIVE_CTO_COLOR:
            const currentConfig = state[action.sku]
			return Object.assign({}, state, { [action.sku]: {...currentConfig, ...action.config }});
		default:
			return state;
	}
};

export default AddOnReducer;
